import Model from './Model'

export default class WebinarCategory extends Model {

	static entity = 'webinarCategory'
	static endpoint = '/cms/webinars/categories'

	static fields () {
		return {
			id: this.attr(),
			title: this.string(''),
			description: this.string()
		}
	}

}



// WEBPACK FOOTER //
// ./src/store/models/WebinarCategory.js